/** Fehler aus der API mit deutschem Text vom Server. */
export class ApiFehler extends Error {
  constructor(
    public status: number,
    text: string,
  ) {
    super(text);
  }
}

type Methode = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';

async function anfrage<T>(methode: Methode, pfad: string, body?: unknown): Promise<T> {
  const istForm = body instanceof FormData;
  const r = await fetch(pfad, {
    method: methode,
    credentials: 'same-origin',
    headers: {
      'x-beholder': '1',
      ...(body !== undefined && !istForm ? { 'content-type': 'application/json' } : {}),
    },
    body: body === undefined ? undefined : istForm ? body : JSON.stringify(body),
  });
  const text = await r.text();
  const daten = text ? safeJson(text) : null;
  if (!r.ok) {
    const meldung = (daten as { fehler?: string } | null)?.fehler ?? `Fehler ${r.status}`;
    if (r.status === 401) window.dispatchEvent(new CustomEvent('beholder:abgemeldet'));
    if (r.status === 403 && meldung === 'Bitte zuerst das Passwort ändern') {
      window.dispatchEvent(new CustomEvent('beholder:passwort'));
    }
    throw new ApiFehler(r.status, meldung);
  }
  return daten as T;
}

function safeJson(t: string): unknown {
  try {
    return JSON.parse(t);
  } catch {
    return t;
  }
}

export const api = {
  get: <T>(pfad: string) => anfrage<T>('GET', pfad),
  post: <T>(pfad: string, body: unknown = {}) => anfrage<T>('POST', pfad, body),
  patch: <T>(pfad: string, body: unknown = {}) => anfrage<T>('PATCH', pfad, body),
  put: <T>(pfad: string, body: unknown = {}) => anfrage<T>('PUT', pfad, body),
  delete: <T>(pfad: string, body: unknown = {}) => anfrage<T>('DELETE', pfad, body),
  /** Dateien hochladen (multipart). */
  hochladen: <T>(pfad: string, dateien: File[] | FileList) => {
    const fd = new FormData();
    for (const d of Array.from(dateien)) fd.append('datei', d, d.name);
    return anfrage<T>('POST', pfad, fd);
  },
};

/** Pfad zu einer Modul-API: /api/projekte/<id>/<bereich>/<rest> */
export function modulPfad(projektId: string, bereich: string, rest = ''): string {
  return `/api/projekte/${projektId}/${bereich}${rest ? (rest.startsWith('/') ? rest : `/${rest}`) : ''}`;
}
